(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dj-catalog-b2b"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function updateCard(card, variantId, variantUrl) {
      if (!card) return;

      var quoteBase = card.getAttribute('data-quote-base') || '';
      var productUrl = card.getAttribute('data-product-url') || '';

      var finalUrl = '';
      if (quoteBase && quoteBase.length) {
        finalUrl = quoteBase + (quoteBase.indexOf('?') >= 0 ? '&' : '?') + 'variant=' + encodeURIComponent(variantId);
      } else {
        finalUrl = productUrl + '?variant=' + encodeURIComponent(variantId);
      }

      var link = card.querySelector('[data-quote-link]');
      if (link) link.setAttribute('href', finalUrl);

      var pills = card.querySelectorAll('.dj-pill');
      pills.forEach(function(p) {
        p.classList.toggle('is-active', p.getAttribute('data-variant-id') === String(variantId));
      });

      var mediaLink = card.querySelector('.dj-card__media');
      var titleLink = card.querySelector('.dj-card__title a');
      if (variantUrl) {
        if (mediaLink) mediaLink.setAttribute('href', variantUrl);
        if (titleLink) titleLink.setAttribute('href', variantUrl);
      }
    }

    document.addEventListener('click', function(e) {
      var pill = e.target.closest('.dj-pill');
      if (!pill) return;

      var card = pill.closest('.dj-card');
      if (!card) return;

      var variantId = pill.getAttribute('data-variant-id');
      var variantUrl = pill.getAttribute('data-variant-url');
      updateCard(card, variantId, variantUrl);
    });

    try {
      var params = new URLSearchParams(window.location.search);
      var v = params.get('variant');
      if (v) {
        document.querySelectorAll('#dj-catalog-{{ section.id }} .dj-card').forEach(function(card) {
          var pill = card.querySelector('.dj-pill[data-variant-id="' + CSS.escape(String(v)) + '"]');
          if (pill) updateCard(card, v, pill.getAttribute('data-variant-url'));
        });
      }
    } catch (err) {}
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
